export default __webpack_public_path__ + "static/media/Phone.769c3adf.svg";